export default {
  baseStyle: {
    borderRadius: "full",
    paddingY: "space-8",
    paddingX: "15px",
    fontWeight: "medium",
    lineHeight: "1.2",
    textTransform: "none"
  },

  sizes: {},

  variants: {
    "orange" : {
      bg: "badge-default",
      color: "text-primary",
      fontWeight: "medium"
    },

    //Default variant - previoulsy blue badge now becomes yellow
    //Since this is dependent on the Prismic data, we are using this variant for fallback
    //We also have  defined a "yellow" variant below to handle new badges coming from Prismic
    "blue": {
      bg: "badge-default",
      color: "text-primary",
      fontWeight: "medium"
    },
    "yellow": {
      bg: "badge-default",
      color: "text-primary",
      fontWeight: "medium"
    },
    "red": {
      bg: "badge-default",
      color: "text-primary",
      fontWeight: "medium"
    },
    'nav-blue': {
      bg: "blue-2",
      borderRadius: "4px",
    },
    'nav-grey': {
      bg: "grey-4",
      borderRadius: "4px",
    },
  },

  defaultProps: {
    variant: "orange",
  },
};
